import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import ItemList from 'components/home/ItemList';

import Body from 'components/shared/Body';
import ErrorBox from 'components/shared/ErrorBox';
import IsOwner from 'components/shared/IsOwner';
import Loading from 'components/shared/Loading';
import MainHeader from 'components/shared/MainHeader';
import Navbar from 'components/shared/Navbar';
import SignedIn from 'components/shared/SignedIn';
import ThemeColor from 'components/shared/ThemeColor';

import PrimaryButton from 'components/shared/buttons/PrimaryButton';

import { ItemsContext } from 'components/shared/context/ItemsContextProvider';
import { ModalContext } from 'components/shared/context/ModalContextProvider';
import { ToastContext } from 'components/shared/context/ToastContextProvider';
import { UserContext } from 'components/shared/context/UserContextProvider';

import BaseInput from 'components/shared/inputs/BaseInput';

import sansanTech from 'services/sansantech';

interface HomePageHeaderSectionProps {
  isOwner: boolean;
}

const HomePageHeaderSection = styled.div<HomePageHeaderSectionProps>`
  display: grid;
  grid-template-columns: ${(props) => (props.isOwner ? '1fr 110px' : '1fr')};
  gap: 20px;

  align-items: flex-end;
`;

const HomePage: React.FC = () => {
  const { userState } = useContext(UserContext);
  const { toastDispatch } = useContext(ToastContext);
  const { openAddItemModal } = useContext(ModalContext);
  const { items, setItems } = useContext(ItemsContext);

  const [searchItemsValue, setSearchItemsValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (userState.token && userState.company) {
      setIsLoading(true);
      sansanTech
        .getItems(userState.token)
        .then((response) => {
          console.log(response);
          setIsLoading(false);
          setItems?.(response.data);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
          toastDispatch?.({ type: 'ERROR', message: 'Could not get items' });
        });
    }
  }, [userState, setItems, toastDispatch]);

  return (
    <SignedIn>
      <Loading isLoading={isLoading}>
        <ThemeColor color="white">
          <Navbar />
          <Body>
            {userState.company ? (
              <>
                <HomePageHeaderSection isOwner={Boolean(userState.isOwner)}>
                  <MainHeader>{userState.company.name}</MainHeader>
                  <IsOwner>
                    <PrimaryButton
                      buttonText="Add item"
                      disabled={false}
                      loading={false}
                      buttonWidth="110px"
                      onClick={() => {
                        openAddItemModal?.();
                      }}
                    />
                  </IsOwner>
                </HomePageHeaderSection>
                <BaseInput
                  label="Search items"
                  type="text"
                  value={searchItemsValue}
                  setValue={setSearchItemsValue}
                  showLabel={false}
                  backgroundColor="#ffffff"
                  placeholder="Search items"
                />
                <ItemList items={items} searchValue={searchItemsValue} />
              </>
            ) : (
              <ErrorBox errorMessage="Your account is not connected to a company yet" />
            )}
          </Body>
        </ThemeColor>
      </Loading>
    </SignedIn>
  );
};

export default HomePage;
